// src/modules/app-views/goodsReceipt/pages/Document/actions/floatButton.js
// *******************************************************************************
// GOODS RECEIPT DOCUMENT FLOAT BUTTON ACTIONS
// *******************************************************************************
// Float button actions for goods receipt document operations.
// Actions visibility rules:
// - Confirm Entry: available only when status is 'draft'
// - Cancel Entry: available only when status is 'confirmed'
// - Cancelled status: no float actions shown
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

// *******************************************************************************
// FLOAT BUTTON ACTIONS
// *******************************************************************************

/**
 * Build float button actions array for goods receipt document
 * @param {Object} context - Context with data and handlers
 * @param {Object} context.data - Goods receipt document data
 * @param {Object} context.handlers - Action handlers
 * @returns {Array} Array of float button action configurations
 */
const goodsReceiptDocumentFloatButton = (context = {}) => {
  const { data, handlers = {} } = context;

  // ─────────────────────────────────────────────────────────────────────────────
  // STATUS CHECKS
  // ─────────────────────────────────────────────────────────────────────────────
  const isNew = !data?._id || data?._id === 'add';
  const status = data?.status;
  const isDraft = !status || status === 'draft';
  const isConfirmed = status === 'confirmed';
  const isCancelled = status === 'cancelled';
  const canConfirm = isDraft || isCancelled;

  // No actions for new documents
  if (isNew) return [];

  // ─────────────────────────────────────────────────────────────────────────────
  // BUILD ACTIONS ARRAY
  // ─────────────────────────────────────────────────────────────────────────────
  const result = [
    // CONFIRM ENTRY - Available when draft or cancelled (re-confirm after correction)
    canConfirm && {
      key: 'confirm',
      icon: <CheckCircleOutlined />,
      tooltipText: 'confirm_entry',
      type: 'primary',
      onClick: handlers.onConfirm,
    },

    // CANCEL ENTRY - Available when goods receipt is confirmed
    isConfirmed && {
      key: 'cancel',
      icon: <CloseCircleOutlined />,
      tooltipText: 'cancel_entry',
      danger: true,
      onClick: handlers.onCancel,
    },
  ].filter(Boolean);

  return result;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default goodsReceiptDocumentFloatButton;
